import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageSquare, FiStar } = FiIcons;

const Testimonials = () => {
  const testimonials = [
    {
      quote: "ArvindInteriors made our Gurgaon flat feel twice as spacious—simply brilliant!",
      author: "Rahul Sharma",
      location: "Gurgaon",
      rating: 5
    },
    {
      quote: "Our Noida office now radiates creativity and professionalism. Clients love it!",
      author: "Priya Verma",
      location: "Noida",
      rating: 5
    },
    {
      quote: "Minimalist luxury at its best—our Delhi home feels like a dream.",
      author: "Amit Khanna",
      location: "Delhi",
      rating: 5
    },
    {
      quote: "Cooking is pure joy in our new modern kitchen. Thank you, ArvindInteriors!",
      author: "Sneha Gupta",
      location: "Residential Project",
      rating: 5
    },
    {
      quote: "They listened, understood, and delivered interiors that fit our lifestyle perfectly.",
      author: "Vikram Singh",
      location: "Bespoke Home",
      rating: 5
    },
    {
      quote: "Our Connaught Place store got a chic makeover—sales have gone up!",
      author: "Rajesh Malhotra",
      location: "Connaught Place",
      rating: 5
    },
    {
      quote: "Family living meets luxury—our Greater Noida villa is stunning yet practical.",
      author: "Anjali Rao",
      location: "Greater Noida",
      rating: 5
    },
    {
      quote: "Smart storage + elegant design = our Ghaziabad apartment feels brand new.",
      author: "Deepak Joshi",
      location: "Ghaziabad",
      rating: 5
    },
    {
      quote: "Guests keep complimenting our interiors—it’s like living in a magazine spread.",
      author: "Meera Reddy",
      location: "Luxury Apartment",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-accent font-medium tracking-widest uppercase text-sm mb-2">Testimonials</p>
          <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold">What Our Clients Say</h2>
          <div className="w-24 h-1 bg-accent mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-surface p-8 rounded-sm border border-gray-100 relative group hover:border-accent/30 transition-colors duration-300 flex flex-col"
            >
              <SafeIcon 
                icon={FiMessageSquare} 
                className="text-accent/10 text-5xl absolute top-6 right-8 group-hover:text-accent/20 transition-colors" 
              />
              
              <div className="flex gap-1 mb-4 relative z-10">
                {[...Array(item.rating)].map((_, i) => (
                  <SafeIcon 
                    key={i} 
                    icon={FiStar} 
                    className="text-accent text-sm fill-accent" 
                  />
                ))}
              </div>

              <p className="text-gray-700 italic leading-relaxed mb-8 relative z-10 flex-grow">
                "{item.quote}"
              </p>
              
              <div className="mt-auto border-t border-gray-100 pt-6">
                <h4 className="text-primary font-serif font-bold text-lg">{item.author}</h4>
                <p className="text-accent text-sm uppercase tracking-wider font-medium">{item.location}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;